import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	UnlikeSupporterVoiceComment,
	type UnlikeSupporterVoiceCommentMutation,
	type UnlikeSupporterVoiceCommentMutationVariables,
} from './index.graphql';

export async function unlikePetitionSupporterComment({
	commentId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	commentId: string;
	utilityContext: UtilityContext;
}): Promise<UnlikeSupporterVoiceCommentMutation | null | undefined> {
	const { data: unlikeResult } = await fetch<
		UnlikeSupporterVoiceCommentMutation,
		UnlikeSupporterVoiceCommentMutationVariables
	>({
		query: UnlikeSupporterVoiceComment,
		variables: { commentId },
		rejectOnError: true,
	});
	return unlikeResult;
}
